import { render } from "./ListDocumentsRow.vue?vue&type=template&id=a89072b4&scoped=true"
import script from "./ListDocumentsRow.vue?vue&type=script&lang=js"
export * from "./ListDocumentsRow.vue?vue&type=script&lang=js"

import "./ListDocumentsRow.vue?vue&type=style&index=0&id=a89072b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89072b4"]])

export default __exports__